import { makeStyles } from '@material-ui/core/styles'

const useMultiSelectStyles = makeStyles(() => ({
  root: {
    width: 300,
  },
}))

export default useMultiSelectStyles
